import { render, staticRenderFns } from "./SmsDetailInfo.vue?vue&type=template&id=356115af&"
import script from "./SmsDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./SmsDetailInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports